/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-15 14:07:07
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-03-26 10:37:46
 * @Description: 平台相关工具方法
 * @FilePath: /hsylc2021/src/utils/plat.js
 */
export default {
  isWeiXin: () => {
    return !!window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i);
  },
  isMobile: () => {
    return !!navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
  },
  isMiniProgram: () => {
    return navigator.userAgent.indexOf('miniProgram') > -1 || localStorage.getItem('debug-miniprogram') === 'true';
  },
  isAMCSite: (() => {
    let isHostMet = window.location.host.indexOf('amc') > -1;
    let isLocalStorageMet = localStorage.getItem('site-amc') === 'true';
    let ret = isHostMet || isLocalStorageMet;
    window.isAMCSite = ret;
    return ret;
  })()
};
